// /app/frontend/src/components/AdminRoute.jsx
//
// Route guard for /admin. Behaves exactly like ProtectedRoute but adds
// a second gate: `user.is_admin` must be truthy. Non-admins get bounced
// to /dashboard so they never see an admin-shaped 404 or a flicker of
// admin UI. The backend still 403s any request, so this is purely UX.

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Same neutral loading state used by ProtectedRoute so the two guards
    // are visually identical during the first-mount /auth/me round-trip.
    return (
      <div className="grid min-h-screen place-items-center bg-white text-zinc-400 dark:bg-zinc-950">
        <div className="text-sm">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user.is_admin) {
    // Silent redirect — do NOT show a "denied" screen. Anyone hitting
    // /admin should feel like the route simply doesn't exist for them.
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
